const CoachVideos = (app) => {
  app.get("/coach-videos/delete/:_id", async ({ req, res, flash, api }) => {
    const { _id } = req.params;

    await api(`coach-videos/?_id=${_id}`, {
      method: "DELETE",
    });

    flash("success", "Successfully deleted");

    return res.backDontScroll();
  });
};

export default CoachVideos;
